import React, { forwardRef, useImperativeHandle, useRef } from 'react';
import ReactECharts from 'echarts-for-react';
import { FormatDateTime } from 'utils/helpers/date_helpers';
import moment from 'moment';

export type EchartGraphType = 'line' | 'bar' | 'candlestick' | 'scatter';

export interface EChartProps {
    type?: EchartGraphType;
    axesType?: 'time' | 'category';
    monitorType?: string; // monitorTypes,
    datas?: any;
    service?: any;
    editable?: any;
    title?: string;
    description?: string;
    mediaLine?: number;
    showAverage?: boolean;
    showLimits?: boolean;
    showMaxValue?: boolean;
    showMinValue?: boolean;
    showZoom?: boolean;
    limits?: number[];
    children?: any;
    onClickedPoint?: any;
    multi?: boolean;
    multiMaps?: any;
    multiType?: any;
    ref?: React.ForwardedRef<unknown>;
}

const EChartDefaults: EChartProps = {
    title: 'titolo',
    description: '',
    monitorType: 'temperature',
    type: 'line',
    axesType: 'category',
    datas: [],
    editable: false,
    showZoom: false,
    multi: false,
};

const EChart: React.FC<EChartProps> = forwardRef(({
    type,
    title,
    service,
    editable,
    monitorType,
    datas,
    mediaLine,
    showAverage,
    showLimits,
    limits,
    onClickedPoint,
    children,
    showZoom,
    multi,
    multiMaps
}, ref) => {
    const refChart = useRef(undefined);
    useImperativeHandle(ref, () => refChart.current);
    let xData = [];
    let yData = [];

    if (datas && Array.isArray(datas)) {
        datas?.map((el) => {
            let date = moment('2000-01-01', "YYYY-MM-DD hh:mm")
                .add(Object.keys(el)[0], 'seconds')
                .format('DD/MM/YYYY hh:mm');
            xData.push(date);
            yData.push(Object.values(el)[0])
            return xData && yData
        })
    }

    const options = {
        grid: { top: 50, right: 8, bottom: 80, left: 50 },
        toolbox: {
            feature: {
                //dataZoom: {},
                //restore: {},
                saveAsImage: {}
            }
        },
        dataZoom: [
            {
                type: 'inside',
                start: 0,
                end: 30
            },
            {
                start: 0,
                end: 30
            }
        ],
        xAxis: {
            type: 'category',
            data: xData,
        },
        yAxis: {
            type: 'value',
        },
        series: [
            {
                data: yData,
                type: 'line',
                smooth: true,
            },
        ],
        tooltip: {
            trigger: 'axis',
        },
    };
    //@ts-ignore
    return <ReactECharts ref={refChart} option={options} />;
});

export default EChart;